import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwq249729q: FaireProductEntity = {
  token: "p_rwq249729q",
  type: "product",
  name: "Best Seller Sample Set of 8, Clean Product Sampler",
  brandToken: "b_3bx0gt904o",
  brandName: "Naive Necessities",
  imageUrl:
    "https://cdn.faire.com/fastly/3dba25ef7dd3d48637823316a8ed16f58976a8500fac397529e638149145e361.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/553b8dce1f06a7a6f1471b761fd56300ef01b0062c74a8ae4761ee6a2528a14f.jpeg",
    "https://cdn.faire.com/fastly/a5f77186a7bac2a4d7d353afc4ddfd4af6e7b417f48a9b418d3fa71be92e465d.png",
    "https://cdn.faire.com/fastly/0ccb1da75a48663caf40110b922b065069f27a3f829b819cbf83a08266c56079.png",
    "https://cdn.faire.com/fastly/ba90d8983dff2c61bfc82849d7c9734881ff7826a3f26ae23d907aa653f01323.png",
    "https://cdn.faire.com/fastly/8c0973df6f94d85b5c46c2bf9c87da7ff55e2ea99fce6fc0093050b2598c3895.jpeg",
    "https://cdn.faire.com/fastly/899699ad3aea1068ae1022df99038eb4f256361a0c5d1271791c539a9dc90970.jpeg",
    "https://cdn.faire.com/fastly/e8b214aa434ff227500c64f814ad3877145f196b0cc3042ed6ee3f423423362c.jpeg",
    "https://cdn.faire.com/fastly/e3042d84c017c85c181feeb92fc499fad9cb1a2d6333110b4956926e6c5a0afb.jpeg",
    "https://cdn.faire.com/fastly/0a09b00e412d285dcc37ee6e8b11a413acfcdcd7dd4cd2f67cc4099cf4b685e7.jpeg",
  ],
  priceDollars: 20,
  description:
    "Finding it difficult to make a decision on purchasing products without experiencing them first? Not sure which products will sell the best in your store or what your customers will love? We get it. Thankfully, we have just the thing - our best seller sample kit! It's a sampler pack of our favorite products that do incredibly well in stores, all bundled in a tidy little bag. Try them out, fall in love, then get $20 off your opening order. It's basically risk free!\n\n*Please message us directly to order a single sample set.*\n\nNOT FOR RESALE. FOR RETAILER SAMPLING ONLY. LIMIT ONE PER RETAILER.\n\nThis set of 8 includes: Magnesium Lotion, Lux Body Butter, Lip Balm, Warming Muscle Gel, Bath Salt Soak, Hair Growth Shampoo, Perfume Rollerball, Elderberry DIY Kit\n\nNo phthalates, parabens, lead, petroleum, or other unnecessary ingredients. Only the very best. Never tested on animals. Made in Pennsylvania. Made in the US.\n\n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:26.169Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
